import MuiCircularProgress from '@mui/material/CircularProgress'
import { styled } from '@mui/material/styles'

export const CircularProgress = styled(MuiCircularProgress)({
  margin: `auto`,
})
